import React, { useState, useEffect } from "react";
import {
    Table,
    Button,
    Space,
    Card
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { ZoomInOutlined } from "@ant-design/icons";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function BusinessPendingPayment() {
    const reports = useReportsStore()
    const { auth, business } = usePersistedStore();
    const general = useGeneralStore();
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const data = reports.pendingPayment.data;
    const loading = reports.pendingPayment.loading;
    const userInfoResources = auth.userInfo.Resources;
    const [requestId, setRequestId] = useState();

    useEffect(() => {
        if (token)
            reports.getPendingPayment();
    }, [token])


    const columns = [
        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "نام کاربر",
            dataIndex: "ApplicantFullName",
            key: "ApplicantFullName",
            width: 200,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
                b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
                return first.localeCompare(second);
            },
        },
        {
            title: "نام بیمه گزار",
            dataIndex: "PolicyOwnerFullName",
            key: "PolicyOwnerFullName",
            width: 250,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PolicyOwnerFullName ? (first = a.PolicyOwnerFullName) : (first = "");
                b.PolicyOwnerFullName ? (second = b.PolicyOwnerFullName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "نام شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 250,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.CompanyName ? (first = a.CompanyName) : (first = "");
                b.CompanyName ? (second = b.CompanyName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: " نام رشته",
            dataIndex: "BranchTitle",
            key: "BranchTitle",
            width: 250,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.BranchTitle ? (first = a.BranchTitle) : (first = "");
                b.BranchTitle ? (second = b.BranchTitle) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "مبلغ مغایرت",
            dataIndex: "ContradictionAmount",
            key: "ContradictionAmount",
            width: 250,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ درخواست",
            dataIndex: "PayableAmount",
            key: "PayableAmount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "وضعیت درخواست",
            dataIndex: "StatusTitle",
            key: "StatusTitle",
            width: 220,

        },
        {
            title: "تاریخ درخواست",
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },


        {
            title: "تاریخ خرید",
            dataIndex: "BuyDate",
            key: "BuyDate",
            width: 110,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.BuyDate ? first = a.BuyDate : first = '';
                b.BuyDate ? second = b.BuyDate : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.BuyDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "مبلغ کل تخفیف",
            dataIndex: "SumDiscountsAmount",
            key: "SumDiscountsAmount",
            width: 250,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.SumDiscountsAmount ? first = a.SumDiscountsAmount : first = '';
                b.SumDiscountsAmount ? second = b.SumDiscountsAmount : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.SumDiscountsAmount === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },

        {
            title: "مبلغ پرداختی ",
            dataIndex: "TotalPayment",
            key: "TotalPayment",
            width: 250,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.TotalPayment ? first = a.TotalPayment : first = '';
                b.TotalPayment ? second = b.TotalPayment : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.TotalPayment === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },

        {
            title: " نوع پرداخت",
            dataIndex: "PaymentTypeName",
            key: "PaymentTypeName",
            width: 120,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PaymentTypeName ? (first = a.PaymentTypeName) : (first = "");
                b.PaymentTypeName ? (second = b.PaymentTypeName) : (second = "");
                return first.localeCompare(second);
            },

        },
    ];

    return (
        <Card>
            <button type="primary" className="btn btn-primary waves-effect waves-light float-left" htmltype="submit"
                onClick={() => reports.getPendingPayment()} style={{ marginBottom: "20px" }}>
                بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
            </button>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={userInfoResources &&
                    (userInfoResources.includes("BusinessSaleReport") ||
                        userInfoResources.includes("BusinessSupportReport")) ?
                    columns : (columns.filter(col => col.dataIndex !== 'operation'))}
                loading={loading}
                rowKey="InsuranceRequestId"
                scroll={true}
                dataSource={data}

            />
            <InsuranceDetails requestId={requestId} />
        </Card>
    );
}


